<div class="main-wrapper">
  <!-- partial:navbar -->
  <ellf-navbar></ellf-navbar>
  <!-- partial -->

  <div class="page-wrapper">
    <div class="page-content">
      <!-- Spinner for lazyload modules -->
      @if (isLoading) {
        <div class="spinner-wrapper">
          <div class="spinner">Loading...</div>
        </div>
      }

      @if (!isLoading) {
        <div contentAnimate>
          <ellf-breadcrumb></ellf-breadcrumb>
          <router-outlet></router-outlet>
        </div>
      }
    </div>

    <!-- partial:footer -->
    <ellf-footer></ellf-footer>
    <!-- partial -->
  </div>
</div>
